const REDIRECTION_ACTION = 'REDIRECTION_ACTION';
const GO_BACK_ACTION = 'GO_BACK_ACTION';
const RESET_TO_HOME_ACTION = 'RESET_TO_HOME';

const redirectAction = location => (
  { type: REDIRECTION_ACTION, location }
);

const goBackAction = () => (
  { type: GO_BACK_ACTION }
);

const resetToHomeAction = () => (
  { type: RESET_TO_HOME_ACTION }
);

export {
  REDIRECTION_ACTION,
  GO_BACK_ACTION,
  RESET_TO_HOME_ACTION,
  redirectAction,
  goBackAction,
  resetToHomeAction,
};



// WEBPACK FOOTER //
// ./src/actions/redirect.js